const previousIcon = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='40'
		height='40'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		stroke-width='1'
		stroke-linecap='round'
		stroke-linejoin='round'
		className='feather feather-chevron-left'
	>
		<polyline points='15 18 9 12 15 6'></polyline>
	</svg>
);

const nextIcon = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='40'
		height='40'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		stroke-width='1'
		stroke-linecap='round'
		stroke-linejoin='round'
		className='feather feather-chevron-right'
	>
		<polyline points='9 18 15 12 9 6'></polyline>
	</svg>
);

const closeIcon = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='30'
		height='30'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		stroke-width='1'
		stroke-linecap='round'
		stroke-linejoin='round'
		className='feather feather-x'
	>
		<line x1='18' y1='6' x2='6' y2='18'></line>
		<line x1='6' y1='6' x2='18' y2='18'></line>
	</svg>
);

const downloadIcon = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='30'
		height='30'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		stroke-width='1'
		stroke-linecap='round'
		stroke-linejoin='round'
		className='feather feather-download'
	>
		<path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'></path>
		<polyline points='7 10 12 15 17 10'></polyline>
		<line x1='12' y1='15' x2='12' y2='3'></line>
	</svg>
);

const zoomInIcon = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='30'
		height='30'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		stroke-width='1'
		stroke-linecap='round'
		stroke-linejoin='round'
		className='feather feather-zoom-in'
	>
		<circle cx='11' cy='11' r='8'></circle>
		<line x1='21' y1='21' x2='16.65' y2='16.65'></line>
		<line x1='11' y1='8' x2='11' y2='14'></line>
		<line x1='8' y1='11' x2='14' y2='11'></line>
	</svg>
);

const zoomOutIcon = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='30'
		height='30'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		stroke-width='1'
		stroke-linecap='round'
		stroke-linejoin='round'
		className='feather feather-zoom-out'
	>
		<circle cx='11' cy='11' r='8'></circle>
		<line x1='21' y1='21' x2='16.65' y2='16.65'></line>
		<line x1='8' y1='11' x2='14' y2='11'></line>
	</svg>
);

export { previousIcon, nextIcon, closeIcon, downloadIcon, zoomInIcon, zoomOutIcon };
